import { Text } from "@gcs/design-system/react";
import styled from "styled-components";

export const SectionCertificateContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  paddingTop: "20px",

  [theme.breakpoint.xl()]: {
    flexDirection: "row",
    paddingTop: "60px",
    paddingBottom: "50px",
  },
}));

export const SectionCertificateItem = styled.div(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  height: "190px",
  gap: "32px",
  borderTop: `1px solid ${theme.color.line.medium}`,
  borderLeft: "none",
  padding: "24px 0",

  [theme.breakpoint.lg()]: {
    padding: "0 28px",
    flexDirection: "column",
    borderTop: "none",
    borderLeft: `1px solid ${theme.color.line.medium}`,
  },

  "&:first-child": {
    border: "none",
  },

  svg: {
    maxWidth: "100%",

    [theme.breakpoint.lg()]: {},
  },
}));

export const SectionCertificateItemText = styled(Text)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "500",
  textAlign: "initial",

  [theme.breakpoint.lg()]: {
    fontSize: "18px",
    marginTop: "auto",
    textAlign: "center",
  },

  "&.mobile-label-hidden": {
    display: "none",

    [theme.breakpoint.lg()]: {
      display: "inherit",
    },
  },
}));
